export const DEFAULT_MEDIA_STATE = {
  type: '',
  filePath: '',
  showToConsumer: false,
  thumbnailFilePath: '',
}
